import React, {useState, useEffect} from "react";
import Modal from '@mui/joy/Modal';
import ModalClose from '@mui/joy/ModalClose';
import ModalDialog from '@mui/joy/ModalDialog';
import DialogTitle from '@mui/joy/DialogTitle';
import DialogContent from '@mui/joy/DialogContent';
import DialogActions from '@mui/joy/DialogActions';
import Divider from '@mui/joy/Divider';
import moment from 'moment';
import Grid from '@mui/joy/Grid';
import FormControl from '@mui/joy/FormControl';
import FormLabel from '@mui/joy/FormLabel';
import Input from '@mui/joy/Input';
import { NumericFormat } from 'react-number-format';

function ModalAuthorizationsView( {handleOpen, isOpen, selected}) {

    const doSearchButton = () => { handleOpen(false) }
    
    return (
        <Modal
            aria-labelledby="close-modal-title"
            open={isOpen}
            onClose={() => handleOpen(false) }
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            <ModalDialog>
                <ModalClose variant="outlined" />
                <DialogTitle> Operación:  {selected.comitente_numero + " - " + selected.comitente_descripcion}</DialogTitle>
                <Divider />
                <DialogContent>
                    <Grid container spacing={2} sx={{ flexGrow: 1 }}>
                        <Grid xs={6}>
                            <FormControl>
                                <FormLabel className="form-labels">Nro. Comitente</FormLabel>
                                <Input size="md" type="text" value={selected.comitente_numero} disabled={true}/>
                            </FormControl>
                        </Grid>
                        <Grid xs={6}>
                            <FormControl>
                                <FormLabel className="form-labels">Comitente</FormLabel>
                                <Input size="md" type="text" value={selected.comitente_descripcion} disabled={true}/>
                            </FormControl>
                        </Grid>
                        <Grid xs={6}>
                            <FormControl>
                                <FormLabel className="form-labels">Moneda</FormLabel>
                                <Input size="md" type="text" value={selected.moneda_descripcion} disabled={true}/>
                            </FormControl>
                        </Grid>
                        <Grid xs={6}>
                            <FormControl>
                                <FormLabel className="form-labels">Tipo de Operación</FormLabel>
                                <Input size="md" type="text" value={selected.tipo_de_operacion_descripcion} disabled={true}/>
                            </FormControl>
                        </Grid>
                        <Grid xs={6}>
                            <FormControl>
                                <FormLabel className="form-labels">Fecha de Concertación</FormLabel>
                                <Input size="md" type="text" value={moment(selected.fecha_de_concertacion).format('DD/MM/YYYY')} disabled={true}/>
                            </FormControl>
                        </Grid>
                        <Grid xs={6}>
                            <FormControl>
                                <FormLabel className="form-labels">Fecha de Liquidación</FormLabel>
                                <Input size="md" type="text" value={moment(selected.fecha_de_liquidacion).format('DD/MM/YYYY')} disabled={true}/>
                            </FormControl>
                        </Grid>
                        <Grid xs={6}>
                            <FormControl>
                                <FormLabel className="form-labels">Instrumento</FormLabel>
                                <Input size="md" type="text" value={selected.instrumento_descripcion} disabled={true}/>
                            </FormControl>
                        </Grid>
                        <Grid xs={6}>
                            <FormControl>
                                <FormLabel className="form-labels">Cantidad</FormLabel>
                                <Input size="md" type="text" value={selected.cantidad} disabled={true}/>
                            </FormControl>
                        </Grid>
                        <Grid xs={6}>
                            <FormControl>
                                <FormLabel className="form-labels">Precio</FormLabel>
                                <Input size="md" type="text" value={selected.precio} disabled={true}/>
                            </FormControl>
                        </Grid>
                        <Grid xs={6}>
                            <FormControl>
                                <FormLabel className="form-labels">Bruto</FormLabel>
                                <Input size="md" type="text" value={selected.bruto} disabled={true}/>
                            </FormControl>
                        </Grid>
                        <Grid xs={6}>
                            <FormControl>
                                <FormLabel className="form-labels">Arancel (Importe)</FormLabel>
                                <Input size="md" type="text" value={selected.arancel_importe} disabled={true}/>
                            </FormControl>
                        </Grid>
                        <Grid xs={6}>
                            <FormControl>
                                <FormLabel className="form-labels">Arancel (%)</FormLabel>
                                <Input size="md" type="text" value={selected.arancel} disabled={true}/>
                            </FormControl>
                        </Grid>
                        <Grid xs={6}>
                            <FormControl>
                                <FormLabel className="form-labels">Liquidación (Importe)</FormLabel>
                                <Input size="md" type="text" value={selected.liquidacion_importe} disabled={true}/>
                            </FormControl>
                        </Grid>
                        <Grid xs={6}>
                            <FormControl>
                                <FormLabel className="form-labels">Liquidación (%)</FormLabel>
                                <Input size="md" type="text" value={selected.liquidacion_porcentaje} disabled={true}/>
                            </FormControl>
                        </Grid>
                        <Grid xs={6}>
                            <FormControl>
                                <FormLabel className="form-labels">Neto</FormLabel>
                                <Input size="md" type="text" value={selected.neto} disabled={true}/>
                            </FormControl>
                        </Grid>
                        <Grid xs={6}>
                            <FormControl>
                                <FormLabel className="form-labels">Neto en Pesos</FormLabel>
                                <Input size="md" type="text" value={selected.neto_en_pesos} disabled={true}/>
                            </FormControl>
                        </Grid>
                        <Grid xs={6}>
                            <FormControl>
                                <FormLabel className="form-labels">Neto en Dolares</FormLabel>
                                <Input size="md" type="text" value={selected.neto_en_dolares} disabled={true}/>
                               {/*  <NumericFormat 
                                        displayType="input" 
                                        value={selected.neto_en_dolares} 
                                        decimalScale={2} 
                                        allowLeadingZeros thousandSeparator="." 
                                        decimalSeparator="," 
                                        // prefix={'$'}  
                                        disabled={true}
                                    />  */}
                            </FormControl>
                        </Grid>
                        <Grid xs={6}>
                            <FormControl>
                                <FormLabel className="form-labels">Enviado</FormLabel>
                                {
                                    selected.sent_at !== null ?
                                        <Input size="md" type="text" value={moment(selected.sent_at).format('DD/MM/YYYY')} disabled={true}/>
                                        :
                                        <Input size="md" type="text" value="" disabled={true}/>
                                }
                            </FormControl>
                        </Grid>
                        <Grid xs={6}>
                            <FormControl>
                                <FormLabel className="form-labels">Firmado</FormLabel>
                                {
                                    selected.signed_at !== null ?
                                        <Input size="md" type="text" value={moment(selected.signed_at).format('DD/MM/YYYY')} disabled={true}/>
                                        :
                                        <Input size="md" type="text" value="" disabled={true}/>
                                }
                            </FormControl>
                        </Grid>
                        <Grid xs={6}>
                            <FormControl>
                                <FormLabel className="form-labels">Razon de Envio</FormLabel>
                                {selected.esco_operation_reason_to_send !== null ?
                                    <Input size="md" type="text" value={selected.esco_operation_reason_to_send.display_name} disabled={true}/>
                                    :
                                    <Input size="md" type="text" value="" disabled={true}/>
                                }
                            </FormControl>
                        </Grid>
                    </Grid>
                </DialogContent>
                <Divider />
                <DialogActions>
                    <button type="button" className="btn btn-secondary mb-2 d-grid w-100" onClick={doSearchButton}>Cerrar</button>            
                </DialogActions>
            </ModalDialog>
        </Modal>

    );
}

export default ModalAuthorizationsView;